// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footer__version":"Footer_footer__version__3LvHK"};